<template>
  <div v-if="!startScreenShot">
    <q-dialog
      v-model="drawer.feedback.show"
      position="right"
      full-height
      maximized
      content-class="feedback-form"
      @hide="$v.$reset(), $emit('closeDrawer')"
    >
      <div class="q-pa-lg flex">
        <q-card
          v-bind="options.cardForm"
        >
          <q-card-section v-if="!isSubmitSuccess">
            <header class="flex items-center justify-between q-mb-lg">
              <div class="card-form-title">
                Kirimkan Masukan
              </div>
              <q-btn
                id="feedbackForm-close-btn"
                v-close-popup
                v-bind="options.btnClose"
                size="sm"
              />
            </header>

            <div class="row q-col-gutter-md use-validate">
              <div class="col-12">
                <label>
                  Tulis Masukan Anda
                  <span class="text-negative">*</span>
                </label>

                <q-input
                  v-model="$v.form.message.$model"
                  for="feedbackForm-input"
                  v-bind="options.textarea"
                  :error="$v.form.message.$error"
                  :error-message="$store.state.wording[$store.state.lang].field.empty"
                  dense
                  rows="4"
                  placeholder="Ceritakan kendala yang Anda alami dengan lengkap dan jelas disini..."
                />
              </div>

              <div class="col-12">
                <label>
                  <div>
                    Ambil Screenshot
                    <span class="text-negative">*</span>
                  </div>
                  <div class="text-grey-5">
                    Screenshot akan membantu kami memahami masukan Anda dengan lebih baik
                  </div>
                </label>

                <div
                  class="feedback-form-preview"
                  :class="!!$v.form.image.blob.$error ? 'form-error' : ''"
                >
                  <q-img
                    :src="form.image.preview"
                    :ratio="16/7.5"
                    contain
                  />
                  <q-btn
                    v-if="!!form.image.preview"
                    id="feedbackForm-remove-btn"
                    fab-mini
                    color="negative"
                    class="feedback-form-preview-btn_remove"
                    @click="removeImage()"
                  >
                    <q-icon
                      id="feedbackForm-remove-icon"
                      :name="'img:' + iconTrash"
                      size="18px"
                      class="color-filter-white"
                    />
                  </q-btn>
                  <button
                    v-if="!form.image.preview"
                    id="feedbackForm-add-btn"
                    class="feedback-form-preview-btn_add"
                    @click="addImage()"
                  >
                    <q-icon
                      id="feedbackForm-add-icon"
                      :name="'img:' + iconCamera"
                      size="48px"
                    />
                    <span>Klik untuk ambil screenshot</span>
                  </button>
                </div>
                <div
                  v-if="$v.form.image.blob.$error"
                  class="text-negative"
                >
                  {{ $store.state.wording[$store.state.lang].field.empty }}
                </div>
              </div>

              <div class="col-12">
                <q-btn
                  id="feedbackForm-submit-btn"
                  label="Kirim"
                  v-bind="options.btnPrimary"
                  :loading="loading.submit"
                  class="full-width q-py-xs"
                  @click="fetchUpload"
                />
              </div>
            </div>
          </q-card-section>

          <q-card-section
            v-else
            class="flex items-center justify-center full-height"
          >
            <div class="flex items-center justify-center">
              <q-icon
                id="feedbackForm-success-icon"
                :name="'img:' + iconPaper"
                size="148px"
              />

              <div class="flex items-center justify-center text-center">
                <h3 class="q-mb-md text-h6">
                  Terima Kasih Atas Masukan Anda
                </h3>
                <p>Masukan Anda membantu kami untuk memperbaiki masalah dan meningkatkan layanan Juragan Material</p>
                <q-btn
                  id="feedbackForm-close-popup-btn"
                  v-close-popup
                  label="Tutup"
                  v-bind="options.btnPrimary"
                  class="q-py-xs"
                  style="width: 50%"
                />
              </div>
            </div>
          </q-card-section>
        </q-card>
      </div>
    </q-dialog>
  </div>
</template>

<script>
import { axios } from 'src/boot/axios'
import { LocalStorage } from 'quasar'
import { options } from 'src/component-options'
import { required } from 'vuelidate/lib/validators'

const defaultForm = () => ({
  message: null,
  image: {
    preview: null,
    blob: null
  }
})

export default {
  name: 'FeedbackForm',

  props: {
    showDrawer: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      options,
      iconMailbox: require('src/assets/images/icons/mail-box.svg'),
      iconCamera: require('src/assets/images/icons/40x40-camera-circle.svg'),
      iconTrash: require('src/assets/images/icons/16x16-trash.svg'),
      iconPaper: require('src/assets/images/icons/40x40-paper.svg'),
      startScreenShot: false,
      isSubmitSuccess: false,

      loading: {
        submit: false
      },

      drawer: {
        feedback: {
          show: false
        }
      },

      form: defaultForm()
    }
  },

  computed: {
    payload () {
      return {
        email: LocalStorage?.getItem('user')?.email,
        platform: 'CMS',
        description: this.form?.message,
        reportedFrom: window.location.href
      }
    }
  },

  watch: {
    showDrawer (val) {
      this.drawer.feedback.show = val
    },

    'drawer.feedback.show': function () {
      this.isSubmitSuccess = false
    }
  },

  validations: {
    form: {
      message: {
        required
      },
      image: {
        blob: {
          required
        }
      }
    }
  },

  methods: {
    async addImage () {
      this.startScreenShot = true
      const canvasEl = document.createElement('canvas')
      const canvasElCtx = canvasEl.getContext('2d')
      const videoEl = document.createElement('video')

      try {
        const mediaStream = await navigator.mediaDevices.getDisplayMedia({
          preferCurrentTab: true
        })

        await videoEl.addEventListener('canplay', () => {
          canvasEl.width = videoEl.videoWidth
          canvasEl.height = videoEl.videoHeight

          videoEl.play()

          canvasElCtx.drawImage(videoEl, 0, 0, canvasEl.width, canvasEl.height)
          mediaStream.getVideoTracks()[0].stop()

          canvasEl.toBlob((blob) => {
            Object.assign(blob, { preview: URL.createObjectURL(blob) })

            const file = new File([blob], 'screenshot.png', {
              type: 'image/png',
              lastModified: new Date().getTime()
            })

            const that = this
            const reader = new FileReader()
            reader.readAsDataURL(file)

            reader.onloadend = function (e) {
              that.form.image.preview = e.target.result
              that.$v.form.image.blob.$model = file
            }
          })
        })

        videoEl.srcObject = mediaStream
      } catch (error) {
        console.error('Error:', error)
      }

      this.startScreenShot = false
    },

    removeImage () {
      this.form.image = defaultForm().image
    },

    fetchUpload () {
      this.$v.$touch()

      if (this.$v.$error) {
        this.$q.notify({
          type: 'negative',
          message: this.$store.state.wording[this.$store.state.lang].field.partiallyEmpty
        })

        return false
      }

      this.loading.submit = true

      const data = new FormData()
      data.append('files.attachment', this.form.image.blob)
      data.append('data', JSON.stringify(this.payload))

      axios({
        method: 'post',
        url: 'https://api.juraganmaterial.id/ops/ticket/api/tickets',
        data,
        headers: {
          'Access-Control-Allow-Origin': undefined,
          'Access-Control-Allow-Methods': undefined,
          Accept: undefined,
          Authorization: undefined
        }
      })
        .then(() => {
          this.resetForm()
          this.isSubmitSuccess = true
        })
        .catch((error) => {
          this.$store.dispatch('notify/FETCH_ERROR', error)
        })
        .finally(() => {
          this.loading.submit = false
        })
    },

    resetForm () {
      this.form = defaultForm()
      this.$v.$reset()
    }
  }
}
</script>

<style lang="scss">
  .feedback-form {
    &.q-dialog {
      .card-form {
        max-width: 400px
      }
    }

    &-preview {
      position: relative;
      border: 0;
      background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='10' ry='10' stroke='%23ddd' stroke-width='2' stroke-dasharray='8%2c 13' stroke-dashoffset='69' stroke-linecap='square'/%3e%3c/svg%3e");
      border-radius: 5px;
      overflow: hidden;
      margin: 0 3px 3px 0;

      &.form-error {
        background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='5' ry='5' stroke='%23A74032FF' stroke-width='2' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
        .feedback-form-preview-btn_add {
          color: var(--q-color-negative)
        }
      }

      .q-img {
        border-radius: 7px;
      }

      &-btn_add {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        padding: 0;
        display: flex;
        flex-direction: column;
        color: var(--q-color-primary);
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border: 0;
        background-color: transparent;
      }

      &-btn_remove {
        position: absolute;
        top: 0;
        right: 0;
        margin: .75rem
      }
    }
  }
</style>
